import { observer } from "mobx-react-lite";
import React, { useContext } from "react";

import {
  dataAttribute,
  DataAttributes,
  FontIcon,
  FontSizes,
  Stack,
  Text
} from "@bps/fluent-ui";
import { EpisodeOfCareBadges } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/EpisodeOfCareBadges.tsx";
import { ExpanderButton } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/ExpanderButton.tsx";
import { EpisodeOfCare } from "@stores/clinical/models/EpisodeOfCare.ts";

import { ChangeConditionContext } from "./context/ChangeConditionContext.ts";

enum LinkConditionButtonsLabels {
  LinkCondition = "Link to a condition"
}

interface ChangeConditionExpanderProps {
  reasonForChangeConditionComment?: string;
  currentEpisodeOfCare?: EpisodeOfCare;
}

export const ChangeConditionExpanderButton: React.FC<ChangeConditionExpanderProps> =
  observer(({ currentEpisodeOfCare }) => {
    const {
      showChangeConditionSecondColumn,
      setShowChangeConditionSecondColumn
    } = useContext(ChangeConditionContext);

    return (
      <ExpanderButton
        {...dataAttribute(
          DataAttributes.Element,
          "changeCondition-expander-button"
        )}
        fields={[]}
        errorMessage=""
        onClick={() => {
          setShowChangeConditionSecondColumn(!showChangeConditionSecondColumn);
        }}
        isOpened={showChangeConditionSecondColumn}
        styles={{
          root: {
            maxWidth: "100%",
            margin: 16
          }
        }}
        disabled={false}
      >
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
          <FontIcon
            iconName="documentSet"
            styles={{
              root: {
                fontSize: FontSizes.size16
              }
            }}
          />
          {currentEpisodeOfCare ? (
            <EpisodeOfCareBadges episodeOfCare={currentEpisodeOfCare} />
          ) : (
            <Text> {LinkConditionButtonsLabels.LinkCondition}</Text>
          )}
        </Stack>
      </ExpanderButton>
    );
  });
